module.exports = __webpack_public_path__ + "img/ap-secondary.0058571c.jpg";